module.exports = __webpack_public_path__ + "img/7 packaging.e9b48376.jpeg";